import { EncryptStorage } from 'encrypt-storage';

const storage = EncryptStorage.create(process.env.REACT_APP_ENCRYPT_KEY || "", {
    engine: 'noble',
    storageType: 'localStorage',
});

// encrypt-storage v3 throws when a stored value can't be decrypted (e.g. values written by v2 before
// the upgrade, or a changed key). Treat those as missing and drop them, so returning users don't hit a blank page.
export const encryptLocalStorage = new Proxy(storage, {
    get(target, prop) {
        if (prop === 'getItem') {
            return (key: string, ...args: any[]) => {
                try {
                    return (target.getItem as any)(key, ...args);
                } catch (err) {
                    target.removeItem(key);
                    return undefined;
                }
            };
        }
        const value = Reflect.get(target, prop, target);
        return typeof value === 'function' ? value.bind(target) : value;
    },
});
